import { MaritalStatus, Sex } from '~/src/app/domain/user.models';

export const AppStrings = {
  General: {
    Error: 'Ops, um erro aconteceu! Tente novamente mais tarde.',
  },
  Cep: {
    NotFound: 'CEP não encontrado.',
  },
  CheckUserPage: {
    Title: 'Entrar ou cadastrar',
    LinkAccountsHelp: 'Faça login com o email da sua conta Kopenhagen já existente',
    EmailInput: 'E-mail',
    EmailOrCpfInput: 'E-mail ou CPF',
    CpfInput: 'CPF',
    SubmitButton: 'Continuar',
  },
  LoginPage: {
    Title: 'Login',
    EmailInput: 'E-mail',
    CpfInput: 'CPF',
    EmailLogin: 'E-mail já cadastrado!',
    EmailHelpLogin:
      'O e-mail inserido já está vinculado a outra conta de CPF. Faça o login usando e-mail e senha cadastrados. Caso não lembre, recupere a senha ou entre em contato com o SAC pelo número 0800-100-678.​',
    CpfLogin: 'CPF já cadastrado!',
    HelpLogin:
      'O CPF inserido já está vinculado a outra conta de e-mail. Faça o login usando CPF e senha cadastrados. Caso não lembre, recupere a senha ou entre em contato com o SAC pelo número 0800-100-678.​',
    ExternalProviderLogin: 'E-mail já cadastrado em outra conta',
    ExternalProviderHelp:
      'O e-mail da conta social já está cadastrado. Para associar as contas, faça login com código ou senha.',
    AuthenticationMethodEmail: 'Receber código por e-mail',
    AuthenticationMethodSms: 'Receber código por SMS',
    AuthenticationMethodPassword: 'Entrar com senha',
    PasswordInput: 'Senha',
    PasswordMinLength: 'A senha deve conter pelo menos 8 caracteres',
    PasswordPattern: 'A senha deve conter pelo menos 1 letra e 1 número',
    ForgotPasswordButton: 'Esqueceu sua senha?',
    LoginButton: 'Continuar',
    SignUpButton: 'Cadastro',
  },
  LoginCodePage: {
    Title: 'Insira o código',
    EmailInstructions: 'Enviamos um código para o e-mail:',
    SmsInstructions: 'Enviamos um código para o número de celular:',
    Code: 'Informe o código',
    Submit: 'Acessar',
    ResendCode: 'Reenviar código',
    WrongCode: 'Código incorreto.',
    EmptyCode: 'Insira o código enviado.',
    ResendCodeAlert:
      'Você errou o código 3 vezes seguidas, para a sua segurança será necessário solicitar um novo código.',
    DisabledResendCode: (waitTime: number): string => `Aguarde ${waitTime} segundos para enviar um novo código`,
    ResendCodeMessage: (maskedEmail: string): string => `Código enviado para o e-mail: ${maskedEmail}`,
    ResendCodeMessageSms: (maskedPhoneNumber: string): string => `Código enviado para o celular: ${maskedPhoneNumber}`,
  },
  MFAMethodPage: {
    Title: 'Confirmação de conta',
    HelpTitle: 'Novo dispositivo detectado.',
    HelpDescription: 'Por questões de segurança precisamos verificar a sua conta.',
    SelectMethodTitle: 'Selecione como deseja receber o código de confirmação:',
    MFAMethodEmail: 'Receber código por e-mail',
    MFAMethodSms: 'Receber código por sms',
    SubmitButton: 'Continuar',
  },
  MFACodePage: {
    Title: 'Insira o código',
    EmailInstructions: 'Enviamos um código para o e-mail:',
    SmsInstructions: 'Enviamos um código para o número de celular:',
    Code: 'Informe o código',
    Submit: 'Acessar',
    ResendCode: 'Reenviar código',
    WrongCode: 'Código incorreto.',
    EmptyCode: 'Insira o código enviado.',
    ResendCodeAlert:
      'Você errou o código 3 vezes seguidas, para a sua segurança será necessário solicitar um novo código.',
    DisabledResendCode: (waitTime: number): string => `Aguarde ${waitTime} segundos para enviar um novo código`,
    ResendCodeMessage: (maskedEmail: string): string => `Código enviado para o e-mail: ${maskedEmail}`,
    ResendCodeMessageSms: (maskedPhoneNumber: string): string => `Código enviado para o celular: ${maskedPhoneNumber}`,
  },
  ForgotPassword: {
    Title: 'Recuperar a senha',
    EmailInput: 'E-mail',
    EmailTip: 'Insira o e-mail cadastrado para receber na sua caixa de entrada o link para a alteração da senha',
    CpfTip: 'Um link para alteração de senha será enviado no e-mail vinculado ao CPF em caso de recuperação por CPF',
    SubmitButton: 'Receber link',
    Success: 'O link para a alteração de senha foi enviado ao seu e-mail.',
    HelpTitle: 'Não tem acesso ao e-mail?',
    SAC: 'Entre em contato com o nosso SAC via telefone: 0800 771 7799 ou via WhatsApp (11) 96427-5000 para atualizar os seus dados cadastrais.',
  },
  SignUpPage: {
    Title: 'Cadastro',
    IncompleteTitle: 'Complete o seu cadastro',
    LegacyTitle: 'Atualize seus dados​',
    WelcomeVtexUser: 'Bem vindo! Você já fez compras conosco.',
    WelcomeKopClubUser: 'Bem vindo! Você já é cliente Kop Club.',
    WelcomeLegacyUser: 'Bem vindo! Você já fez compras conosco e é cliente Kop Club.',
    KopClubPoints: 'Seus pontos Kop Club serão mantidos, você poderá consultá-los e ativar resgates em nosso app.',
    LGPDInfo: 'Precisamos que confirme e complete seu cadastro para continuar.',
    NewKopClubUser: 'Seja bem vindo!',
    NewKopClubUserDescription:
      'Complete seu cadastro, faça parte do programa de fidelidade Kop Club e ganhe 50 pontos para trocar por prêmios',
    UserPersonalData: 'Dados pessoais',
    UserAccessData: 'Dados de acesso',
    LinkAccountsHelp: 'Já tem conta cadastrada com outro e-mail?',
    LinkAccountsButton: 'Vincular contas',
    NameInput: 'Nome completo',
    FullNameValidator: 'Insira seu nome completo',
    CpfInput: 'CPF',
    BirthDateInput: 'Data de nascimento',
    BirthDateRegex: 'A data deve estar no formato DD/MM/AAAA',
    EmailInput: 'E-mail',
    MobilePhoneInput: 'Celular com DDD',
    PasswordInput: (isSocialLogin: boolean): string => `Senha ${isSocialLogin ? '(opcional)' : ''}`,
    PasswordTip: 'A senha deve conter pelo menos 8 caracteres, 1 letra e 1 número',
    PasswordMinLength: 'A senha deve conter pelo menos 8 caracteres',
    PasswordPattern: 'A senha deve conter pelo menos 1 letra e 1 número',
    HasInvitationCode: 'Possui código de indicação do Kop Club?',
    InvitationCodeYes: 'Sim, possuo',
    InvitationCodeNo: 'Não possuo',
    InvitationCodeInput: 'Código de Indicação',
    InvitationCodeLength: 'O código de indicação deve conter pelo menos 6 caracteres',
    InvitationCodeCardMessage:
      'Identificamos que você ja faz parte do Kop Club, então não é necessário inserir o código de indicação',
    KopClubOptin: 'Desejo receber promoções e novidades da Kopenhagen',
    EmailOptin: 'E-mail',
    SMSOptin: 'SMS',
    WhatsAppOptin: 'WhatsApp',
    PrivacyTermsHeader: 'Termos de privacidade',
    TermsOptinText: 'Li e concordo com os ',
    CookiePolicyLink: 'Política de Cookies',
    PrivacyPolicyLink: 'Política de Privacidade',
    TermsOptinLink: 'Regulamento Kop Club',
    CoffeeTermsOptinLink: 'Regulamento Café Fidelidade',
    OverSixteen: 'Declaro que tenho 16 anos ou mais',
    SignUpSubmit: 'Cadastrar',
    LegacySignUpSubmit: 'Atualizar',
  },
  UpdateUserPage: {
    NameInput: 'Nome completo',
    FullNameValidator: 'Insira seu nome completo',
    CpfInput: 'CPF',
    BirthDateInput: 'Data de nascimento',
    EmailInput: 'E-mail',
    MobilePhoneInput: 'Celular com DDD',
    SexInput: 'Sexo',
    MaritalStatusInput: 'Estado civil',
    CepInput: 'CEP',
    StreetInput: 'Logradouro',
    Address: 'Endereço',
    AddressNumberInput: 'Número',
    ComplementInput: 'Complemento',
    NeighborhoodInput: 'Bairro',
    CityInput: 'Cidade',
    StateInput: 'Estado',
    KopClubOptin: 'Desejo receber promoções e novidades da Kopenhagen',
    EmailOptin: 'E-mail',
    SMSOptin: 'SMS',
    WhatsAppOptin: 'WhatsApp',
    Submit: 'Salvar',
    SexOptions: {
      [Sex.Empty]: 'Sexo',
      [Sex.Male]: 'Masculino',
      [Sex.Female]: 'Feminino',
      [Sex.Other]: 'Não quero informar',
    },
    MaritalStatusOptions: {
      Empty: 'Estado civil',
      [MaritalStatus.Single]: 'Solteiro',
      [MaritalStatus.Married]: 'Casado',
      [MaritalStatus.Widowed]: 'Viúvo',
      [MaritalStatus.Divorced]: 'Divorciado',
      [MaritalStatus.Separed]: 'Separado',
    },
    Success: 'Cadastro atualizado com sucesso. Para sair, feche essa página.',
  },
  ResetPasswordPage: {
    Title: 'Crie sua nova senha',
    PasswordInput: 'Senha',
    SubmitButton: 'Salvar senha',
  },
  ChangePasswordPage: {
    Title: 'Alteração de senha',
    EmailInput: 'E-mail',
    CurrentPasswordInput: 'Senha atual',
    NewPasswordInput: 'Nova senha',
    SubmitButton: 'Alterar senha',
  },
  TermsPage: {
    Title: 'Regulamento',
  },
  CookiesPolicyPage: {
    Title: 'Política de Cookies',
  },
  PrivacyPolicyPage: { Title: 'Política de Privacidade' },
};
